import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject
} from '@angular/core';
import { MatSidenav, MatDialog } from '@angular/material';
import { SpinnerService } from '../../shared/components/spinner/spinner.service';
import { IconService } from '@shared/services/icon.service';
import { SocketService } from '@shared/services/socket.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { IUser } from '@shared/models/login.model';
import { CloseEventsComponent } from './components/close-events/close-events.component';
import { environment } from 'src/environments/environment';
import { IEvent as Event } from '@shared/models/socket.mode';
import { UserService } from '@shared/services/user.service';
import { AutoLogoutService} from '@shared/services/auto-logout-service.service';
import { EtaReminderComponent } from '@shared/components/eta-reminder/eta-reminder.component';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  providers: [
    {
      provide: SocketService,
      useFactory: () => x => new SocketService()
    }
  ]
})
export class MainLayoutComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  opened = false;

  @ViewChild(MatSidenav, { static: true }) sidenav: MatSidenav;
  @ViewChild('sidebarBgImage', { static: false }) sidebarBgImage: ElementRef;
  @ViewChild('appSidebar', { static: false }) appSidebar: ElementRef;
  @ViewChild('wrapper', { static: false }) wrapper: ElementRef;
  changeDetector;
  public hideSidebar: boolean;
  public expanded: boolean;
  public user: IUser;
  public showChat = false;

  private instanceOne;
  private instanceTwo;
  private AutoLogout;
  newMessages: number = 0;

  constructor(
    public spinnerService: SpinnerService,
    private iconService: IconService,
    @Inject(SocketService) socketService: any,
    @Inject(AutoLogoutService) autoLogoutService: any,
    public dialog: MatDialog,
    private userService: UserService
  ) {
    super();
    this.instanceOne = socketService(1);
    this.instanceTwo = socketService(2);
    this.user = this.userService.userInfo;
    this.AutoLogout=autoLogoutService;
  }

  ngOnInit() {
    this.iconService.registerIcons();
    this.socketIOInit();
    this.setSideBarStatus();
    //AutoLogoutService.call;

  }

  toggleHideSidebar(): void {
    this.hideSidebar = !this.hideSidebar;
    localStorage.setItem(
      'sidebar_status',
      !this.hideSidebar ? 'true' : 'false'
    );
  }

  socketIOInit() {
    // instance one
    this.instanceOne.initSocket(
      environment.socketUrl + '/CLIENTOPERATOR',
      localStorage.getItem('JWT_TOKEN')
    );

    this.subs.add(this.instanceOne.onEvent(Event.CONNECT).subscribe(e => {}));

    this.subs.add(
      this.instanceOne
        .onEvent('op-taskReminder-' + this.user.id)
        .subscribe(data => {
          data = data.response;
          if (data.user_id == this.user.id) {
            this.dialog.open(CloseEventsComponent, {
              width: '380px',
              data: {
                type_event: 'close',
                body: {
                  taskInfo: {
                    ...data,
                    email: data.email_address,
                    phone: data.phone_number
                  },
                  task: data.type,
                  action: data.action_email
                    ? 'email'
                    : data.action_call
                    ? 'call'
                    : 'followup',
                  date: data.date,
                  id: data.id
                }
              },
              hasBackdrop: false,
              position: { top: '50px', right: '15px' },
              panelClass: 'create-task-modal'
            });
          }
        })
    );

    this.subs.add(
      this.instanceOne
        .onEvent('op-checkConnection-all')
        .subscribe(
          (data: {
            response: { databaseStatus: boolean; message: string };
          }) => {
            localStorage.setItem(
              'DB-DOWN',
              !data.response.databaseStatus ? 'YES' : 'NO'
            );
            if (!data.response.databaseStatus) {
              // If the db is down the local Storage item DB-DOWN is YES for 40s while db is restored
              setTimeout(() => {
                localStorage.setItem('DB-DOWN', 'NO');
              }, 40000);
            }
          }
        )
    );

    this.subs.add(
      this.instanceOne
        .onEvent('op-orderEtaReminder-'+ this.user.id)
        .subscribe(
          (data: {
            response: { fd_number: string,dispatcher_id: number; order_id: number };
          }) => {
            if(this.user.id == data.response.dispatcher_id) {
                this.showEtaReminder(data.response.fd_number);
              }
          }
        )
    );

  }
  
  showEtaReminder(fd_number: string): void {
    this.dialog.open(EtaReminderComponent, {
      width: '300px',
      data: { fd_number }
    });
  }

  setCounterNewMessages(event) {
    if (!this.showChat) this.newMessages++;
  }

  private setSideBarStatus() {
    const status = JSON.parse(localStorage.getItem('sidebar_status'));
    this.expanded = status !== null ? status : false;
    localStorage.setItem('sidebar_status', this.expanded ? 'true' : 'false');
    this.hideSidebar = !this.expanded;
  }
}
